import deletedItemsList  from '@/api/mart-sale/deleted-items-list';
import { baseState, baseMutations } from '@/store/mixins';
import moment from 'moment'

export const state = {
  ...baseState,
  status: '',
  date_from: moment()
    .add('days', -7)
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}


export const mutations = {
  ...baseMutations,
   SET_STATUS(state, data) {
    state.status = data
  },
   SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
}


export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        filter: {
          search: context.state.search,
          status: context.state.status
        }
      },
      attributes
    )
    return deletedItemsList.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },


}